import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import RootState from '../../../types/RootState'
import { formatUTCDate } from '../../../utils/stringTools'

interface Props {
  show: boolean;
  onClose: () => void;
}

const ProviderDetailModal: FC<Props> = (props: Props) => {
  const { show, onClose } = props

  const { providerDetailToUpdate } = useSelector((state: RootState) => ({
    providerDetailToUpdate: state.providerDetail.providerDetailToUpdate.data,
  }))

  const columns = [{
    dataField: 'providerName',
    text: 'Location Name',
    sort: false,
  }, {
    dataField: 'openingsUpdatedDate',
    text: 'Openings Updated Date',
    sort: false,
    formatter: (cellContent) => ( cellContent && formatUTCDate(cellContent) ) || 'N/A',
  }]

  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton id="switch-organization-header">
        <FontAwesomeIcon icon={['fas', 'user-circle']} size="lg" className="switch-organization-header-icon" />
        <Modal.Title id="switch-organization-header-title">Location Detail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>Please provide the missing openings for these Locations. You can update the information in the &quot;Location Details&quot; tab</p>
          <ToolkitProvider
            keyField='providerId'
            bootstrap4
            data={providerDetailToUpdate}
            columns={columns}
          >
            {
              props => (
                <div id='providerDetailTableContainer' style={{width: '100%'}}>
                  <BootstrapTable
                    id='providerDetailToUpdateTable'
                    bordered={false}
                    striped
                    condensed
                    bootstrap4
                    { ...props.baseProps }
                  />
                </div>
              )
            }
          </ToolkitProvider>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ProviderDetailModal 